import React from 'react'
import PropTypes from 'prop-types'
import times from 'lodash/times'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import { getSignalFontVariantName } from '@signal/theme'

import { Wrapper, Skeleton } from './styles'

export const TypographySkeleton = ({
  style = undefined,
  variant = 'body2',
  lines = 1,
  color = 'skeletonPrimary',
  fill = undefined,
  width = undefined,
  inverse = undefined,
  align = undefined,
  noSkeletonClass = false,
  ...rest
}) => {
  return (
    <Wrapper width={width} align={align} {...rest}>
      {times(lines, i => (
        <Skeleton
          className={noSkeletonClass ? undefined : 'pure-skeleton'}
          key={i}
          styles={style}
          variant={getSignalFontVariantName(variant)}
          color={color}
          last={i === lines - 1 && lines > 1}
          fill={fill}
          inverse={inverse}
          width={width}
        />
      ))}
    </Wrapper>
  )
}

TypographySkeleton.propTypes = {
  style: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.oneOf([
    'skeletonPrimary',
    'skeletonDark',
    'textPrimary',
    'textSecondary',
    'textDark',
    'primary',
    'secondary',
    'success',
    'error',
    'inverse'
  ]),
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'body3',
    'body4',
    'caption'
  ]),
  lines: PropTypes.number,
  inverse: PropTypes.bool,
  fill: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right'])
}

TypographySkeleton.defaultProps = {
  variant: 'body2',
  lines: 1,
  color: 'skeletonPrimary'
}

export default withCommonSnapshotsOnly(TypographySkeleton)
